import request from '@/utils/request'

const adminUrl = '/base/'

export function getUserInfo(userId) {
  return request({
    url: adminUrl + 'user/' + userId,
    method: 'get'
  })
}
export function getMessageList(params) {
  return request({
    url: adminUrl + 'message/getUnReadInSystemMessageList',
    method: 'get',
    params
  })
}
export function getMenuList(params) {
  return request({
    url: adminUrl + 'resource/visit/commonlyWithLanguage',
    method: 'get',
    params
  })
}
export function getCollectList(params) {
  return request({
    url: adminUrl + 'baseUserResourceCollect/list',
    method: 'get',
    params
  })
}
